import { useSettings } from '@wu/widget-core';
import { DataProvider } from './DataProvider';
import { MenuItem } from './MenuItem';

export function List() {
  const { menus = [] } = useSettings();

  if (menus.length === 0) {
    return null;
  }

  return (
    <>
      {menus.map((item) => (
        <DataProvider data={item} key={item.id}>
          <MenuItem />
        </DataProvider>
      ))}
    </>
  );
}
